// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';

/**
 * @class Jsw.Collapsible
 * @extends Jsw.Container
 */
export const Collapsible = Class.create(Container, {
    /**
     * @cfg {String} html Inner html.
     */
    /**
     * @cfg {Boolean} collapsed=true
     */

    _initConfiguration($super, config) {
        $super(config);
        this._contentAreaId = `${this._id}-content-area`;
        this._anchorAreaId = `${this._id}-anchor-area`;
    },

    _initComponentElement($super) {
        $super();

        const containerContentChilds = this._componentElement.childElements();

        this._updateComponentElement(
            '<div class="collapsible-box collapsed">' +
                `<div class="collapsible-anchor" id="${this._anchorAreaId}"></div>` +
                '<div class="collapsible-area">' +
                    '<div class="tl"><div class="br"><div class="bl"><div class="tr">' +
                        `<div class="collapsible-content" id="${this._contentAreaId}">${this._getConfigParam('html', '')}</div>` +
                    '</div></div></div></div>' +
                '</div>' +
             '</div>'
        );
    },

    _addEvents($super) {
        $super();

        // init collapsed status
        if (this._getConfigParam('collapsed', true)) {
            this.collapse();
        } else {
            this.expand();
        }
        // handle click event on anchor
        this._componentElement.select('.collapsible-anchor').each(function (anchorElement) {
            Event.observe(anchorElement, 'click', this._onAnchorClickEvent.bind(this));
        }, this);
    },

    _onAnchorClickEvent(event) {
        if (this._collapsed) {
            this.expand();
        } else {
            this.collapse();
        }
        Event.stop(event);
    },

    _getCollapseBinding() {
        if (!this._collapseBinding) {
            this._collapseBinding = this.collapse.bind(this);
        }
        return this._collapseBinding;
    },

    /**
     * Collapse component.
     */
    collapse() {
        if (this._collapsed) {
            return;
        }
        this._collapsed = true;
        Event.stopObserving(document, 'click', this._getCollapseBinding());
        const content = $(this._contentAreaId).up('.collapsible-box');
        content.removeClassName('expanded');
        content.addClassName('collapsed');
    },

    /**
     * Expand component.
     */
    expand() {
        if (!this._collapsed) {
            return;
        }
        this._collapsed = false;
        const content = $(this._contentAreaId).up('.collapsible-box');
        content.removeClassName('collapsed');
        content.addClassName('expanded');
        Event.observe(document, 'click', this._getCollapseBinding());
    },
});



// WEBPACK FOOTER //
// ./jsw/collapsible.js